"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListBucketInventoryConfigurationsInput_1 = require("./ListBucketInventoryConfigurationsInput");
var ListBucketInventoryConfigurationsOutput_1 = require("./ListBucketInventoryConfigurationsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListBucketInventoryConfigurations = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListBucketInventoryConfigurations",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?inventory"
    },
    input: {
        shape: ListBucketInventoryConfigurationsInput_1.ListBucketInventoryConfigurationsInput
    },
    output: {
        shape: ListBucketInventoryConfigurationsOutput_1.ListBucketInventoryConfigurationsOutput
    },
    errors: []
};
//# sourceMappingURL=ListBucketInventoryConfigurations.js.map